import { useMutation, useQuery } from "@tanstack/react-query";
import { folderAttachmentApiService } from "./folder.api";


interface ApiResponse<T = any> {
    data: T;
    message: string;
    statuscode: number;
}

export const useFolderService = (
    searchText?: string | null,
    studyid?: number | null,
    pageNumber: number = 1,
    pageSize: number = 10,
    isEnabled: boolean = true,
) => {
    const SelectAllQuery = useQuery({
        queryKey: ["folder-selectAll", studyid, searchText, pageNumber, pageSize],
        queryFn: () =>
            folderAttachmentApiService.getSelectAllData(
                searchText,
                studyid,
                pageNumber,
                pageSize,
            ),
        enabled: !!pageNumber && !!pageSize && isEnabled && !!studyid,
    });

    const InsertMutation = useMutation<ApiResponse, Error, any>({
        mutationFn: (payload: any) =>
            folderAttachmentApiService.insertData(payload),
    });

    const DeleteMutation = useMutation<ApiResponse, Error, any>({
        mutationFn: (payload) => folderAttachmentApiService.deleteData(payload),
    });

    const UpdateMutation = useMutation<ApiResponse, Error, any>({
        mutationFn: (payload) => folderAttachmentApiService.updateData(payload),
    });

    return {
        SelectAllQuery,
        InsertMutation,
        DeleteMutation,
        UpdateMutation,
    };
};